import React from "react";
import "./contact.css";
import ContactForm from "../contactForm/contactForm";
import Map from "../map/map";
import BookNow from "../bookNow/bookNow";

const Contactus = () => {
  return (
    <>
      <div className="relative w-full md:min-h-screen h-[75%] ">
        {/* Background Image - Full Width */}
        <div className="absolute inset-0 w-full h-full  bg-cover bg-center bgContactBanner z-0"></div>

        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-50 z-0"></div>

        {/* Content Wrapper */}
        <div className="relative z-10 flex flex-col items-center justify-center md:h-screen h-[700px] text-center text-white px-4">
          <div className="flex flex-col gap-4 ">
            <div className="flex gap-3 justify-center">
              <div className="text-base poppins-medium">HOME</div>
              <div className="text-base poppins-medium">/</div>
              <div className="text-base poppins-medium">CONTACT US</div>
            </div>
            <h2 className="text-3xl md:text-6xl font-normal ">
              CONTACT <span className="text-[#D1A752] underline"> US</span>
            </h2>
          </div>
        </div>
      </div>
      <ContactForm />
      <Map />
      <BookNow />
    </>
  );
};

export default Contactus;
